<app-mobile-tabs
	[activeColumn]="showColumn"
	[personType]="personType"
	(onClick)="updateShowColumnLocal($event)"
/>

<app-banner
	[person]="payor || contact"
	[type]="personType"
/>

<div class="person-content swipe-parent">
	<!-- <div
      #center
		[hidden]="
			eventsService.isMobile &&
			(showColumn | inArray: ['calendar', 'sideItems'])
		"
      > -->
	@if (payor || contact) {
		<div
			#center
			class="center-area swipe-child"
		>
			@if (curCenter) {
				@switch (curCenter) {
					@case ("contactway") {
						<div class="panel panel-default panel-documents">
							<div class="panel-head">
								<div class="col-12">
									<button
										class="close back-to"
										tabindex="-1"
										titleLang="back_to_details"
										(click)="backToMain()"
										preIcon="modal-close"
									>
										<span class="back-to-details">{{
											"back_to_details" | langVal
										}}</span>
									</button>
								</div>
							</div>
							<div class="panel-body">
								<app-gen-table2
									[filterField]="personType + '_id'"
									[filterFieldValue]="(contact || payor).id"
									tableName="contactways"
									(changeHappened)="leftSideUpdate($event, 'contactways')"
								/>
							</div>
						</div>
					}
					@case ("reminder") {
						<div class="panel panel-default">
							<div class="panel-head">
								<div class="col-12">
									<button
										class="close back-to"
										tabindex="-1"
										titleLang="back_to_details"
										(click)="backToMain()"
										preIcon="modal-close"
									>
										<span class="back-to-details">{{
											"back_to_details" | langVal
										}}</span>
									</button>
								</div>
							</div>
							<div class="panel-body">
								<app-gen-table
									[filterField]="personType + '_id'"
									[filterFieldValue]="(contact || payor).id"
									tableName="notifications"
									isEditDisabled
								/>
							</div>
						</div>
					}
					@case ("invoice") {
						<div class="panel panel-default panel-finresources">
							<div class="panel-head">
								<div class="col-12">
									<button
										class="close back-to"
										tabindex="-1"
										titleLang="back_to_details"
										(click)="backToMain()"
										preIcon="modal-close"
									>
										<span class="back-to-details">{{
											"back_to_details" | langVal
										}}</span>
									</button>
								</div>
							</div>
							<div class="panel-body">
								<app-gen-table2
									#finresourceTable
									[filterField]="personType + '_id'"
									[filterFieldValue]="(contact || payor).id"
									[tableName]="
										is_finresource_connected_only == 'yes'
											? 'open_proformas'
											: 'finresources'
									"
								/>
								<div class="panel-options">
									<div id="reports-financial">
										@if (payor) {
											<button
												titleLang="follow_ups_report"
												tabindex="-1"
												class="btn btn-primary"
												(click)="openReport('followups_report')"
											>
												{{ "follow_ups_report" | langVal }}
											</button>
										}
										<button
											titleLang="income"
											tabindex="-1"
											class="btn btn-primary"
											(click)="openReport('invoices_report')"
										>
											{{ "income" | langVal }}
										</button>
										<button
											titleLang="bankaccounts"
											tabindex="-1"
											class="btn btn-primary"
											(click)="
												modalProps = { name: 'table-display-bankaccounts' }
											"
										>
											{{ "bankaccounts" | langVal }}
										</button>
										<div style="padding-inline-start: 4px">
											<app-gen-button-group
												[actualObj]="this"
												fieldName="is_finresource_connected_only"
												optionsListName="is_finresource_connected_only"
												optionFieldId="value"
											/>
										</div>
									</div>
									<div class="mis-auto">
										<button
											titleLang="invoice_short"
											tabindex="-1"
											class="btn btn-primary"
											(click)="addInvoice()"
											postIcon="plus"
										>
											{{ "invoice_short" | langVal }}
										</button>
									</div>
								</div>
							</div>
						</div>
					}
					@case ("document") {
						<div class="panel panel-default panel-documents">
							<div class="panel-head">
								<div class="col-12">
									<button
										class="close back-to"
										tabindex="-1"
										titleLang="back_to_details"
										(click)="backToMain()"
										preIcon="modal-close"
									>
										<span class="back-to-details">{{
											"back_to_details" | langVal
										}}</span>
									</button>
								</div>
							</div>
							<div class="panel-body">
								<app-gen-table2
									#documentsTable
									filterField="payor_id"
									[filterFieldValue]="payor.id"
									tableName="documents"
								/>
								<div class="panel-options">
									<button
										titleLang="letter"
										tabindex="-1"
										class="btn btn-primary"
										(click)="modalProps = { name: 'add-document' }"
										postIcon="plus"
									>
										{{ "letter" | langVal }}
									</button>

									<button
										titleLang="upload_file"
										tabindex="-1"
										class="btn btn-primary"
										(click)="modalProps = { name: 'upload-document' }"
										postIcon="plus"
									>
										{{ "upload_file" | langVal }}
									</button>
								</div>
							</div>
						</div>
					}
				}
			} @else {
				<div class="center-area">
					@if (contact) {
						<app-update-contact
							[contact]="contact"
							(addInvoiceEv)="addInvoice()"
						/>
					}
					@if (payor) {
						<app-update-payor
							[payor]="payor"
							(addInvoiceEv)="addInvoice()"
							(openReport)="openReport($event)"
							(addDocumentEv)="modalProps = { name: 'add-document' }"
							(openUploadDocumentModalEv)="
								modalProps = { name: 'upload-document' }
							"
						/>
					}
				</div>
			}
		</div>
	}
	<!-- </div> -->

	@if (contact || payor) {
		<!-- <div
			[hidden]="
				eventsService.isMobile && (showColumn | inArray: ['calendar', 'center'])
			"
                    id="person-side-col"
                    class="side-scroll"
                    #center
                    > -->
		<div
			id="side-patient-col"
			class="swipe-child"
			#sideItemsDiv
		>
			@for (sideItem of sideItems; track sideItem) {
				<app-person-side-item
					[color]="color"
					[sideItem]="sideItem"
					[curCenter]="curCenter"
					(click)="curCenter = sideItem.name; updateShowColumnLocal('center')"
					class="pointer"
				>
					<div class="person-side-items">
						@switch (sideItem.name) {
							@case ("contactway") {
								@for (
									contactway of (contact || payor).contactways | slice: 0 : 4;
									track contactway
								) {
									<div class="d-flex gap-1">
										<div class="contactway">
											{{ $any(contactway).contactway }}
										</div>
										<div>
											{{
												$any(contactway).name
													? " - " + $any(contactway).name
													: ""
											}}
										</div>
									</div>
								}
							}
							@case ("document") {
								@for (
									document of payor.documents | slice: 0 : 4;
									track document
								) {
									<div class="document-div">
										<div class="col">
											{{ $any(document).title_dec || $any(document).title }}
										</div>
										<div class="col text-end">
											{{ $any(document).date | dateFormat }}
										</div>
									</div>
								}
							}
							@case ("invoice") {
								@if (payor) {
									<div class="totals-format">
										<div>
											{{ ("total_lm_debt" | langVal) + " - " }}
											<span>{{ payor.total_until_lm_debt | finNumber }}</span>
										</div>
										@if (payor.total_total_debt >= 0) {
											<div>
												{{ ("total_total_debt" | langVal) + ": " }}
												<span>{{ payor.total_total_debt | finNumber }}</span>
											</div>
										} @else {
											<div>
												{{
													("total_total_credit" | langVal) + payor.name + ": "
												}}
												<span>{{ -payor.total_total_debt | finNumber }}</span>
											</div>
										}
									</div>
								}
							}
						}
					</div>
				</app-person-side-item>
			}
		</div>
	}
</div>
@switch (modalProps?.name) {
	@case ("reports") {
		<app-reports
			isModalMode
			(onClose)="modalProps = null"
			[report_name]="modalProps.report_name"
			filterFieldName="item_id"
			[filterFieldValue]="getPerson().id"
			[filterFieldShown]="getPerson().name"
			[item_type]="personType"
		/>
	}
	@case ("add-invoice") {
		<app-add-invoice
			(onClose)="handleAddInvoiceClose()"
			[description]="modalProps.description"
			[paid_by]="getPerson().name"
			[is_withholding_tax]="getPerson().is_withholding_tax"
			[withholding_tax_percent]="getPerson().withholding_tax_percent"
			[for]="getPerson().name"
			[resource]="personType"
			[resourceId]="getPerson().id"
		/>
	}
	@case ("upload-document") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="upload_file"
		>
			<app-upload-document
				(onClose)="modalProps = null"
				[payor_id]="payor.id"
			/>
		</app-modal-wrap>
	}
	@case ("add-document") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="letter"
			modalWrapperClass="modal-800"
		>
			<app-add-document
				(onClose)="modalProps = null"
				[payor_id]="payor.id"
				[title]="payor.name"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-bankaccounts") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="bankaccounts"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="modalProps = null"
				tableName="bankaccounts"
				[filterField]="personType + '_id'"
				[filterFieldValue]="getPerson().id"
			/>
		</app-modal-wrap>
	}
}
